import { render, staticRenderFns } from "./building-library.vue?vue&type=template&id=8e3318c6&"
import script from "./building-library.vue?vue&type=script&lang=js&"
export * from "./building-library.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports